import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=1b7d78c9&scoped=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=1b7d78c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d78c9",
  null
  
)

export default component.exports